// 'use strict';

// /* ===================================================================================== @preserve =
//  ___  _   _    _
// /   || | | |  | |
// \__  | | | |  | |  __
// /    |/  |/_) |/  /  \_/\/
// \___/|__/| \_/|__/\__/  /\_/
//               |\
//               |/
// Ajaxinate
// version v2.0.11
// https://github.com/Elkfox/Ajaxinate
// Copyright (c) 2017 Elkfox Co Pty Ltd
// https://elkfox.com
// MIT License
// ================================================================================================= */

// var Ajaxinate = function ajaxinateConstructor(config) {
//   var settings = config || {};
//   var defaultSettings = {
//     pagination: '#AjaxinatePagination',
//     method: 'scroll',
//     container: '#AjaxinateLoop',
//     offset: 0,
//     loadingText: 'Loading...',
//     callback: null,
//   };
//   this.settings = Object.assign(defaultSettings, settings);
//   this.addScrollListeners = this.addScrollListeners.bind(this);
//   this.addClickListener = this.addClickListener.bind(this);
//   this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
//   this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
//   this.destroy = this.destroy.bind(this);
//   this.containerElement = document.querySelector(this.settings.container);
//   this.paginationElement = document.querySelector(this.settings.pagination);
//   this.isLoading = false; // Flag to prevent multiple AJAX requests
//   this.initialize();
// };

// Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
//   if (!this.containerElement) return;

//   // Add product click listeners
//   this.removeProductListeners();
//   this.addProductListeners();

//   // Check localStorage for restoration
//   let productInfo = JSON.parse(localStorage.getItem('product-info'));
//   if (productInfo?.product_id) {
//     let { product_id: productID, page_number: targetPageNumber } = productInfo;
//     localStorage.removeItem('product-info'); // Clear immediately
//     // Load all pages up to target and scroll to product, no infinite scroll
//     this.loadAllPagesToTarget(1, productID, targetPageNumber);
//   } else {
//     // Normal infinite scroll or click behavior
//     var initializers = {
//       click: this.addClickListener,
//       scroll: this.addScrollListeners,
//     };
//     initializers[this.settings.method]();
//   }
// };

// Ajaxinate.prototype.addProductListeners = function addProductListeners() {
//   let allProducts = document.querySelectorAll('.product-card-wrapper');
//   allProducts.forEach((product) => {
//     product.removeEventListener('click', this.handleProductClick);
//     product.addEventListener('click', this.handleProductClick.bind(this));
//   });
// };

// Ajaxinate.prototype.handleProductClick = function handleProductClick(event) {
//   let product = event.currentTarget;
//   let collectionHandle = product.getAttribute('collection-handle');
//   let productHandle = product.getAttribute('product-handle');
//   let productID = Number(product.getAttribute('product-id'));
//   let pageNumber = Number(product.getAttribute('page-number'));

//   let productInfo = {
//     collection_handle: collectionHandle,
//     product_handle: productHandle,
//     product_id: productID,
//     page_number: pageNumber,
//   };
//   localStorage.setItem('product-info', JSON.stringify(productInfo));
// };

// Ajaxinate.prototype.removeProductListeners = function removeProductListeners() {
//   let allProducts = document.querySelectorAll('.product-card-wrapper');
//   allProducts.forEach((product) => {
//     product.removeEventListener('click', this.handleProductClick);
//   });
// };

// Ajaxinate.prototype.loadAllPagesToTarget = function loadAllPagesToTarget(currentPage, productID, targetPageNumber) {
//   let collectionOverlay = this.querySelector('.infinite-module-overlay');
//   if (currentPage > targetPageNumber) {
//     this.scrollToProduct(productID);
//     this.initialize();
//     if(collectionOverlay){
//       collectionOverlay.style.display = 'none';
//     }
//     return;
//   }
//   if (this.paginationElement && this.paginationElement.querySelector('a') && !this.isLoading) {
//     this.isLoading = true;
//     this.nextPageLinkElement = this.paginationElement.querySelector('a');
//     this.nextPageUrl = this.nextPageLinkElement.href;
//     this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//     if(collectionOverlay){
//       collectionOverlay.style.display = 'block';
//     }

//     this.request = new XMLHttpRequest();
//     this.request.onreadystatechange = function success() {
//       if (this.request.readyState === 4) {
//         this.isLoading = false;
//         if (this.request.status === 200) {
//           var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
//           var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
//           this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
//           this.paginationElement.innerHTML = newPagination ? newPagination.innerHTML : '';
//           if (this.settings.callback && typeof this.settings.callback === 'function') {
//             this.settings.callback(this.request.responseXML);
//           }
//           // Update product listeners for new content
//           this.removeProductListeners();
//           this.addProductListeners();
//           // Load next page
//           this.loadAllPagesToTarget(currentPage + 1, productID, targetPageNumber);
//         } else {
//           console.error(`Failed to load page ${currentPage}: ${this.nextPageUrl}, status: ${this.request.status}`);
//           this.scrollToProduct(productID); // Attempt to scroll anyway
//           if (this.paginationElement) {
//             this.paginationElement.innerHTML = ''; // Prevent further loading
//           }
//         }
//       }
//     }.bind(this);
//     this.request.open('GET', this.nextPageUrl);
//     this.request.responseType = 'document';
//     this.request.send();
//   } else {
//     console.warn(`No pagination available or loading in progress at page ${currentPage}`);
//     this.scrollToProduct(productID); // Attempt to scroll if pagination is missing
//     if (this.paginationElement) {
//       this.paginationElement.innerHTML = ''; // Prevent further loading
//     }
//   }
// };

// Ajaxinate.prototype.scrollToProduct = function scrollToProduct(productID) {
//   let attempts = 0;
//   const maxAttempts = 10;
//   const interval = 100;
//   const checkAndScroll = () => {
//     const targetDiv = document.getElementById(`product-id-${productID}`);
//     if (targetDiv) {
//       targetDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     } else if (attempts < maxAttempts) {
//       attempts++;
//       setTimeout(checkAndScroll, interval);
//     } else {
//       console.warn(`Product with ID ${productID} not found after ${maxAttempts} attempts.`);
//     }
//   };
//   checkAndScroll();
// };

// Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
//   if (this.paginationElement) {
//     this.checkIfPaginationInView = this.debounce(this.checkIfPaginationInView, 100);
//     document.addEventListener('scroll', this.checkIfPaginationInView);
//     window.addEventListener('resize', this.checkIfPaginationInView);
//     window.addEventListener('orientationchange', this.checkIfPaginationInView);
//   }
// };

// Ajaxinate.prototype.debounce = function debounce(func, wait) {
//   let timeout;
//   return function executedFunction(...args) {
//     const later = () => {
//       clearTimeout(timeout);
//       func.apply(this, args);
//     };
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// };

// Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
//   if (this.paginationElement) {
//     this.nextPageLinkElement = this.paginationElement.querySelector('a');
//     this.clickActive = true;
//     if (this.nextPageLinkElement) {
//       this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
//     }
//   }
// };

// Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
//   event.preventDefault();
//   if (this.clickActive && !this.isLoading) {
//     this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//     this.nextPageUrl = this.nextPageLinkElement.href;
//     this.clickActive = false;
//     this.loadMore();
//   }
// };

// Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
//   if (!this.paginationElement || this.isLoading) return;
//   var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
//   var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
//   if (top <= window.innerHeight && bottom >= 0) {
//     this.nextPageLinkElement = this.paginationElement.querySelector('a');
//     if (this.nextPageLinkElement) {
//       this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//       this.nextPageUrl = this.nextPageLinkElement.href;
//       this.loadMore();
//     }
//   }
// };

// Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
//   if (this.isLoading) return;
//   this.isLoading = true;
//   this.request = new XMLHttpRequest();
//   this.request.onreadystatechange = function success() {
//     if (this.request.readyState === 4) {
//       this.isLoading = false;
//       if (this.request.status === 200) {
//         var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
//         var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
//         this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
//         this.paginationElement.innerHTML = newPagination ? newPagination.innerHTML : '';
//         if (this.settings.callback && typeof this.settings.callback === 'function') {
//           this.settings.callback(this.request.responseXML);
//         }
//         // Update product listeners
//         this.removeProductListeners();
//         this.addProductListeners();
//         // Reinitialize scroll listeners
//         this.removeScrollListener();
//         this.addScrollListeners();
//       } else {
//         console.error(`Failed to load page: ${this.nextPageUrl}, status: ${this.request.status}`);
//       }
//     }
//   }.bind(this);
//   this.request.open('GET', this.nextPageUrl);
//   this.request.responseType = 'document';
//   this.request.send();
// };

// Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
//   if (this.nextPageLinkElement) {
//     this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
//   }
// };

// Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
//   document.removeEventListener('scroll', this.checkIfPaginationInView);
//   window.removeEventListener('resize', this.checkIfPaginationInView);
//   window.removeEventListener('orientationchange', this.checkIfPaginationInView);
// };

// Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
//   var destroyers = {
//     click: this.removeClickListener,
//     scroll: this.removeScrollListener,
//   };
//   destroyers[this.settings.method]();
//   this.removeProductListeners();
//   return this;
// };








'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: "Loading...",
    callback: null,
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialize the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    };
    initializers[this.settings.method]();

    // Use event delegation to handle clicks on dynamically loaded product cards
    this.containerElement.addEventListener('click', (event) => {
      const product = event.target.closest('.product-card-wrapper');
      if (product) {
        let collectionHandle = product.getAttribute('collection-handle');
        let productHandle = product.getAttribute('product-handle');
        let productID = Number(product.getAttribute('product-id'));
        let pageNumber = Number(product.getAttribute('page-number'));

        let productInfo = {
          collection_handle: collectionHandle,
          product_handle: productHandle,
          product_id: productID,
          page_number: pageNumber,
        };

        // Store product info in localStorage
        let productInfoJson = JSON.stringify(productInfo);
        localStorage.setItem('product-info', productInfoJson);

        // Log the updated localStorage value to verify
        // console.log('Updated localStorage:', JSON.parse(localStorage.getItem('product-info')));
      }
    });
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      if (newPagination == undefined || newPagination == null) {
        this.paginationElement.classList.add('hidden');
      }
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  destroyers[this.settings.method]();
  return this;
};